// extracted by mini-css-extract-plugin
module.exports = {"mobile":"index_mobile__pr4L0","form":"index_form__lG7n3","prefix":"index_prefix__MPLgb","btn":"index_btn__KY5tE","val":"index_val__Jd6aJ"};